// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: App.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var App = App || {};

(function (ns, $) {

    ns.mobileContentNav = function () {
        $('.toggle-left-col').click(function (e) {
            e.stopPropagation();
            $('body').addClass('on-canvas');
            $('.page-column--left').addClass('expanded');
        });
        $('.toggle-left-col__close, .info-widget-wrap a, .mobile-mask').not('.linked-name').click(function () {
            $('.page-column--left').removeClass('expanded');
            $('body').removeClass('on-canvas');
        });
    };

    ns.searchSidebar = function () {
        ns.checkTooTall();
        $(window).on('scroll', ns.checkTooTall);
    };

    ns.checkTooTall = function () {
        var issueNavHeight = $('.info-inner-wrap').height();
        var win = $('#ContentColumn').height();
        if (issueNavHeight > win) {
            $('.info-inner-wrap').addClass('im-too-tall');
        }
    };
    
    // ----
    // Modals
    // ----
    // for complex modals that copy content
	ns.contentModals = function () {
        $('a[reveal-id]').each(function () {
            if ($(this).hasClass('xref-fn')) {

                $(this).click(function () {
                    var modalTriggerId = $(this).attr('reveal-id');
                    var targetModal = $('.fn[content-id="' + modalTriggerId + '"]');
                    var refModalContents = $(targetModal).html();
                    $('body').addClass('on-canvas');
                    $(refModalContents).clone().appendTo('#revealModal #revealContent').addClass('ref-modal');
                    $('.ref-modal').closest('.reveal-modal').addClass('open');
                });

                $('.close-reveal-modal').on('click', function () {
                    $(this).closest('.reveal-modal').removeClass('open');
                    $('.ref-modal').html('').removeClass('ref-modal');
                    $('body').removeClass('on-canvas');
                });

            }
        });
        if (!$('.pg_ArticleSplitView, .pg_articlesplitview').length) {
            $('.reveal-modal').attr('aria-hidden', 'true');
            $('a[reveal-id]').each(function () {
                var $link = $(this);
                if ($link.hasClass('xref-fn')) {

                    $link.click(function () {
                        var modalTriggerId = $(this).attr('reveal-id');
                        var $targetModal = $('.fn[content-id="' + modalTriggerId + '"]');
                        var refModalContents = $targetModal.html();
                        $('body').addClass('on-canvas');
                        $(refModalContents).clone().appendTo('#revealModal #revealContent').addClass('ref-modal');
                        var $openedModal = $('.ref-modal').closest('.reveal-modal');
                        $openedModal.addClass('open');
                        setAccesibilityAttributes($openedModal, true, modalTriggerId);
                        $openedModal.attr('tabindex', '-1');
                        $openedModal.scrollTop(0);

                        $(document.body).off('keyup.contentModals');

                        $(document.body).on('keyup.contentModals', function (e) {
                            if (e && e.code && e.code.toLowerCase() === 'escape' && $openedModal.hasClass('open')) {
                                $('.ref-modal').html('').removeClass('ref-modal');
                                closeModal($openedModal, $link);
                            }
                        });

                        $('.close-reveal-modal').on('click.contentModalsClose', function () {
                            var $openedModal = $(this).closest('.reveal-modal');
                            if ($openedModal.hasClass('open')) {
                                $('.ref-modal').html('').removeClass('ref-modal');
                                $(this).off('click.contentModalsClose');
                                closeModal($openedModal, $link);
                            }
                        });
                    });

                } else {
                    var modalTriggerId = $link.attr('reveal-id');
                    var $targetModal = $('.reveal-modal[content-id="' + modalTriggerId + '"]');
                    $link.click(function (e) {
                        if ($targetModal.length) {
                            e.stopPropagation();
                            $('body').addClass('on-canvas');
                            $targetModal.addClass('open');
                            setAccesibilityAttributes($targetModal, true, modalTriggerId);
                            $targetModal.attr('tabindex', '-1');
                            $targetModal.scrollTop(0);

                            $(document.body).off('click.contentModals keyup.contentModals');

                            $(document.body).on('click.contentModals', function () {
                                if ($targetModal.hasClass('open')) {
                                    closeModal($targetModal, $link);
                                }
                            });
                            $(document.body).on('keyup.contentModals', function (e) {
                                if (e && e.code && e.code.toLowerCase() === 'escape' && $targetModal.hasClass('open')) {
                                    closeModal($targetModal, $link);
                                }
                            });

                            $('.close-reveal-modal').on('click.contentModalsClose', function () {
                                var $openedModal = $(this).closest('.reveal-modal');
                                if ($openedModal.hasClass('open')) {
                                    $('.ref-modal').html('').removeClass('ref-modal');
                                    $(this).off('click.contentModalsClose');
                                    closeModal($openedModal, $link);
                                }
                            });
                        }
                    });
                }
            });
        }
    };

    function closeModal($modal, $trigger) {
        $modal.removeClass('open');
        $('body').removeClass('on-canvas');
        setAccesibilityAttributes($modal, false, $trigger.attr('id'));
        $(document.body).off('click.contentModals keyup.contentModals');
    }

    function setAccesibilityAttributes($modal, isOpen, modalTriggerId) {
        if (!$modal || !$modal.length) {
            return;
        }

        if (isOpen) {
            $modal.attr('aria-hidden', 'false');
            $modal.attr('aria-live', 'assertive');

            var $label = $modal.find('.label').first();

            if ($label.length) {
                var labelId = $label.attr('id');

                if (!labelId) {
                    labelId = 'modal-label-' + modalTriggerId;
                    $label.attr('id', labelId);
                }

                $modal.attr('aria-labelledby', labelId);
            } else {
                $modal.removeAttr('aria-labelledby');
            }

        } else {
            $modal.attr('aria-hidden', 'true');
            $modal.removeAttr('aria-live');
            $modal.removeAttr('aria-labelledby');
        }
    }
	
    ns.alignIssueCoverModalVertically = function () {
        $('.reveal-modal').has('.IssueCoverFigure')
            .css('top', '0');
    };

    // ----
    // Initialization functions
    // ----
    ns.init = function () {
        ns.mobileContentNav();
        ns.alignIssueCoverModalVertically();
        ns.searchSidebar();
    };

    ns.windowLoadInit = function () {
        ns.contentModals();
    };

})(App.SiteJS = App.SiteJS || {}, jQuery);


// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($, undefined) {

    // Document Ready Event: DOM fully loaded
    $(document).ready(function () {
        App.SiteJS.init(); // init general JS module for site
        //App.PDFAccess.init(); // init PDF module from scm.sharedcontrols.pdfaccess.js
        if ($('body').hasClass('pg_ArticleSplitView') === true) {
            // theme client.script.js file will initialize splitscreen js only for article page. 
            // as we do splitscreen for chapter as well, we are calling init explictly for it.
            SCM.SplitScreen.init();
        }
        if ($('body').hasClass('pg_Chapter') === true) {
            // theme client.script.js file will initialize splitscreen js only for article page. 
            // as we do splitscreen for chapter as well, we are calling init explictly for it.
            SCM.SplitScreen.init();
        }
    });

    // Window Load Event: Images done loading
    $(window).on('load', function () {
        App.SiteJS.windowLoadInit();
    });

    // Window Resize Event
    $(window).on('resize', function () {
        // all functions contained within the the resize event should be throttled or debounced in some way.
        // see the debounce function located in App.JSUtility.js
    });

})(jQuery);
